import { render } from "./HistoryChangeModules.vue?vue&type=template&id=4bef0542&scoped=true"
import script from "./HistoryChangeModules.vue?vue&type=script&lang=js"
export * from "./HistoryChangeModules.vue?vue&type=script&lang=js"

import "./HistoryChangeModules.vue?vue&type=style&index=0&id=4bef0542&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bef0542"]])

export default __exports__